// /frontend/src/routes/EmployerRoute.jsx
import React, { useState, useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../Context/AuthContext";
import API from "../helpers/API";
import Spinner from "../ui/Spinner/Spinner";

export const EmployerRoute = () => {
  const [ok, setOk] = useState(false);
  const [auth, setAuth] = useAuth();

  useEffect(() => {
    const authCheck = async () => {
      // Quick client‑side role check: if role !== 2, redirect
      if (auth.user?.role !== 2) {
        setOk(false);
        return;
      }
      try {
        const res = await API.get("/auth/employerRoute");
        if (res.data.ok) {
          setOk(true);
        } else {
          setOk(false);
        }
      } catch (error) {
        console.error("Employer route check failed:", error);
        setOk(false);
      }
    };
    if (auth?.token) authCheck();
    else setOk(false);
  }, [auth?.token, auth.user?.role]);

  // If not authenticated or not employer, redirect to login
  if (!auth.token || !auth.user) {
    return <Navigate to="/Login" replace />;
  }

  // Show spinner while checking
  if (ok === false && auth.user?.role === 2) {
    return <Spinner path="" />;
  }

  return ok ? <Outlet /> : <Navigate to="/Login" replace />;
};
